// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Registo_container__Ceher{
        display: flex;
        justify-content: center;
        text-transform: capitalize;
    }

    .Registo_container__Ceher > div {
        width: 100%;
        margin-top: 15px;
    }

   .Registo_options__yfNMx{
        display: flex;
        place-content: center;
   }

   .Registo_form__blYGt{
        display: flex;
        font-size: 18px;
        margin-top: 20px;
        place-content: center;
   }

   .Registo_paper__nTk-X{
       width: 50%;
       padding: 2% 5%;
   }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    .Registo_container__Ceher{
        text-transform: capitalize;
    }
    
    .Registo_container__Ceher > div {
        width: 100%;
        margin-top: 15px;
    }

    .Registo_options__yfNMx{
        display: flex;
        place-content: center;
    }
 
    .Registo_form__blYGt{
        display: flex;
        font-size: 18px;
        margin-top: 15px;
        place-content: center;
    }
 
    .Registo_paper__nTk-X{
        width: 65%;
        padding: 2% 5%;
    }
}

/*MOBILE*/
@media screen and (max-width:767px) {
    .Registo_container__Ceher {
        display: flex;
        place-content: center;
        text-transform: capitalize;
    }

    .Registo_container__Ceher > div {
        width: 100%;
        margin-top: 15px;
    }

    .Registo_options__yfNMx{
        display: flex;
        place-content: center;
    }
 
    .Registo_form__blYGt{
        margin-top: 20px;
        font-size: 18px;
    }
 
    .Registo_paper__nTk-X{
        margin: auto;
        padding: 5%;
        max-width: 370px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/registo/Registo.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;GAED;QACK,aAAa;QACb,qBAAqB;GAC1B;;GAEA;QACK,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,qBAAqB;GAC1B;;GAEA;OACI,UAAU;OACV,cAAc;GAClB;AACH;;AAEA,SAAS;AACT;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .container{\n        display: flex;\n        justify-content: center;\n        text-transform: capitalize;\n    }\n\n    .container > div {\n        width: 100%;\n        margin-top: 15px;\n    }\n\n   .options{\n        display: flex;\n        place-content: center;\n   }\n\n   .form{\n        display: flex;\n        font-size: 18px;\n        margin-top: 20px;\n        place-content: center;\n   }\n\n   .paper{\n       width: 50%;\n       padding: 2% 5%;\n   }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    .container{\n        text-transform: capitalize;\n    }\n    \n    .container > div {\n        width: 100%;\n        margin-top: 15px;\n    }\n\n    .options{\n        display: flex;\n        place-content: center;\n    }\n \n    .form{\n        display: flex;\n        font-size: 18px;\n        margin-top: 15px;\n        place-content: center;\n    }\n \n    .paper{\n        width: 65%;\n        padding: 2% 5%;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .container {\n        display: flex;\n        place-content: center;\n        text-transform: capitalize;\n    }\n\n    .container > div {\n        width: 100%;\n        margin-top: 15px;\n    }\n\n    .options{\n        display: flex;\n        place-content: center;\n    }\n \n    .form{\n        margin-top: 20px;\n        font-size: 18px;\n    }\n \n    .paper{\n        margin: auto;\n        padding: 5%;\n        max-width: 370px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Registo_container__Ceher`,
	"options": `Registo_options__yfNMx`,
	"form": `Registo_form__blYGt`,
	"paper": `Registo_paper__nTk-X`
};
export default ___CSS_LOADER_EXPORT___;
